import React from "react";
import { Checkbox, Body1, mergeClasses } from "@fluentui/react-components";
import { ICartItemOptionGroup, ICartItemOption } from "../Schema";
import { useStyles } from "./Styles";

type MultiSelectOptionGroupProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  optionGroup: ICartItemOptionGroup;
  setValue: (value: ICartItemOptionGroup) => void;
  disabled?: boolean;
};

export const MultiSelectOptionGroup = React.forwardRef<HTMLDivElement, MultiSelectOptionGroupProps>(
  (props: MultiSelectOptionGroupProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    const styles = useStyles();
    const { optionGroup, setValue, ...rest } = props;

    const updateSelected = React.useCallback(
      (index: number, value: ICartItemOption) => ({
        ...optionGroup,
        options: [
          ...optionGroup.options.slice(0, index),
          value,
          ...optionGroup.options.slice(index + 1),
        ],
      }),
      [optionGroup],
    );
    return (
      <div data-testid="multiSelectOptionGroup" ref={ref} {...rest} className={styles.field}>
        {optionGroup.options?.map((option, index) => (
          <Checkbox
            disabled={props.disabled}
            aria-required={optionGroup.minimum > 0}
            data-testid="multiSelectOption"
            className={
              option.isSelected ? mergeClasses(styles.checked, styles.option) : styles.option
            }
            key={option.id}
            value={option.id}
            checked={option.isSelected}
            label={
              <Body1>
                {option.name}
                {option.price.amount > 0 &&
                  `(+ ${option.price.currencyUnit}${option.price.amount.toFixed(2)})`}
              </Body1>
            }
            onChange={(e, data) => {
              const value: ICartItemOptionGroup = updateSelected(index, {
                ...option,
                isSelected: data.checked as boolean,
              });
              setValue(value);
            }}
          />
        ))}
      </div>
    );
  },
);

MultiSelectOptionGroup.displayName = "MultiSelectOptionGroup";
